<div class="container">
  <div>
    <span>{{ data.message }} </span>
    <a class="accent" [href]="data.link">{{ 'action.open' | translate }} </a>
  </div>

  <div class="accent button" (click)="onClose()">{{ 'action.ok' | translate }}</div>
</div>
